__turbopack_context__.v({
  "body": "Table-module__-U5Cwa__body",
  "cell": "Table-module__-U5Cwa__cell",
  "detailsCell": "Table-module__-U5Cwa__detailsCell",
  "detailsOpen": "Table-module__-U5Cwa__detailsOpen",
  "detailsRow": "Table-module__-U5Cwa__detailsRow",
  "dynamicHeight": "Table-module__-U5Cwa__dynamicHeight",
  "emptyTableHint": "Table-module__-U5Cwa__emptyTableHint",
  "head": "Table-module__-U5Cwa__head",
  "root": "Table-module__-U5Cwa__root",
  "row": "Table-module__-U5Cwa__row",
  "toggleDetails": "Table-module__-U5Cwa__toggleDetails",
});
